<head>
  <!-- Google Tag Manager -->
  <script>
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N73Z6Q5S');
  </script>
  <!-- End Google Tag Manager -->
</head>

<div *ngIf="isLaoding">
  <div class="loader">
    <div class="loader-circle"></div>
    <span class="loader-text">Carregando blog...</span>
  </div>
</div>

<body>
  <section class="blog-area" style="background: #cecece 0% 0% no-repeat padding-box; width: 100%">
    <!-- Google Tag Manager (noscript) -->
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-N73Z6Q5S"
        height="0"
        width="0"
        style="display: none; visibility: hidden"></iframe>
    </noscript>
    <!-- End Google Tag Manager (noscript) -->

    <div class="container">
      <div class="row">
        <div class="col-lg-7 mb-4" *ngIf="listaBlogsPaginated && listaBlogsPaginated.length > 0">
          <div class="blog-loop">
            <div class="single-blog-post">
              <div class="post-thumbnail">
                <img src="data:image/jpg;base64,{{ postDestaque.imagemDestacada }}" alt="Image" />
                <a href="#" target="_black" class="tag-blog">
                  <div
                    *ngFor="let categoryRightTitle of postDestaque.categoriesDTO; let indexCategoryRightTitle = index">
                    <div>
                      <span class="span-badge-geia badge badge-success">{{ categoryRightTitle.nome }}</span>
                    </div>
                  </div>
                </a>
              </div>
              <div class="post-content" style="border-bottom-left-radius: 20px; border-bottom-right-radius: 20px">
                <h3 class="post-title">
                  <a href="https://portal.geia.com.br/blog/Post/{{ postDestaque.id }}" target="_black">
                    {{ postDestaque.titulo | uppercase }}
                  </a>
                </h3>
                <p>
                  {{ toHTML(postDestaque.descricao) }}
                </p>

                <ul class="post-meta">
                  <li class="post-share">
                    <a
                      href="https://portal.geia.com.br/blog/Post/{{ postDestaque.id }}"
                      target="_blank"
                      class="bold-azul bold-azul-geia">
                      <i class="bold-azul bold-azul-geia">
                        <b>CONTINUE LENDO</b>
                      </i>

                      <i class="fa fa-arrow-right bold-azul-geia"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 mb-4 mt-blog-mobile" *ngIf="listaBlogsPaginated && listaBlogsPaginated.length > 0">
          <div class="primary-sidebar">
            <div class="about-content mt-md-50">
              <div class="section-heading">
                <span class="subt-title-left span-30px">
                  Blog
                  <i class="title-left">Últimos Post</i>
                </span>
                <div *ngFor="let blogItem of listaBlogsPaginated; let i = index">
                  <div *ngFor="let categoryRightTitle of blogItem.categoriesDTO; let indexCategoryRightTitle = index">
                    <div>
                      <span class="span-badge-geia badge badge-success">{{ categoryRightTitle.nome }}</span>
                    </div>
                  </div>
                  <h2 (click)="postDetails('blogItem.id')" class="title-left font-title-blog-h2">
                    <a
                      class="cursor-pointer"
                      target="_blanck"
                      href="https://portal.geia.com.br/blog/Post/{{ blogItem.id }}">
                      {{ blogItem.titulo | uppercase }}
                    </a>
                  </h2>
                  <ul class="post-meta float-right">
                    <li>
                      <a class="text-color time-blog">
                        <i class="far fa-calendar-alt"></i>
                        {{ getWeekDescription(blogItem.data) }}
                      </a>
                    </li>
                  </ul>
                  <div>
                    <p class="linha-divisoria"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</body>
